import { render, staticRenderFns } from "./Actionable.vue?vue&type=template&id=2256c46d"
import script from "./Actionable.vue?vue&type=script&lang=js"
export * from "./Actionable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports